"use client"

import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "components/ui/toast"
import { useToast } from "components/ui/use-toast"
import React from "react"

export function Toaster() {
  const { toasts, dismiss } = useToast()

  return (
    <div className="toast-content">
        <ToastProvider duration={5000}>
            {toasts.map(function ({ id, title, description, action, variant, ...props }) {
                let descriptionText: string;

                try {
                    if (typeof description === "string") {
                        descriptionText = description
                    } else if (
                    description &&
                    typeof description === "object" &&
                    "message" in description &&
                    typeof (description as any).message === "string"
                    ) {
                        // Probablemente un Error u objeto similar
                        descriptionText = (description as any).message
                    } else if (typeof description === "object" && description !== null) {
                        descriptionText = JSON.stringify(description, null, 2)
                    } else if (description != null) {
                        descriptionText = String(description)
                    }
                } catch {
                    descriptionText = "⚠️ Error converting description to string";
                }
                return (
                <Toast key={id} variant={variant} {...props} onClick={() => {console.log("closing toast..."); dismiss(id);}}>
                    <div className="grid gap-1">
                    {title && <ToastTitle className="toast-title">{title}</ToastTitle>}
                    {description && <ToastDescription className="toast-description">{descriptionText}</ToastDescription>}
                    </div>
                    {action}
                    <ToastClose className="toast-close-button">
                        <i className="fas fa-times" />
                    </ToastClose>
                </Toast>
                )
            })}
            <ToastViewport />
            </ToastProvider>
    </div>
    
  )
}
